var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoiceDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.6H15.2C15.3051 1.6 15.4091 1.62069 15.5061 1.6609C15.6032 1.7011 15.6914 1.76003 15.7657 1.83431C15.84 1.9086 15.8989 1.99679 15.9391 2.09385C15.9793 2.19091 16 2.29494 16 2.4V15.2C16 15.4122 15.9157 15.6157 15.7657 15.7657C15.6157 15.9157 15.4122 16 15.2 16H0.8C0.587827 16 0.384344 15.9157 0.234315 15.7657C0.0842855 15.6157 0 15.4122 0 15.2L0 2.4C0 2.18783 0.0842855 1.98434 0.234315 1.83431C0.384344 1.68429 0.587827 1.6 0.8 1.6H4V0H5.6V1.6H10.4V0H12V1.6ZM14.4 8H1.6V14.4H14.4V8ZM10.4 3.2H5.6V4.8H4V3.2H1.6V6.4H14.4V3.2H12V4.8H10.4V3.2Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoiceDate);
export default __webpack_public_path__ + "static/media/choiceDate.39042891fbbf76990fd7ec376c16f79d.svg";
export { ForwardRef as ReactComponent };